import React from "react";
import { I18n } from "react-redux-i18n";

interface IProps {
  width?: number;
  height?: number;
  title?: string;
}

export const Visa: React.FC<IProps> = ({ width, height, title }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="45.18 134.43 659.63 202.12"
  >
    <title>{title || I18n.t("hoverIcons.visa")}</title>
    <g id="visa">
      <path id="Shape" fill="#0E4595" d="M278.198,334.228l33.36-195.763h53.358l-33.384,195.763H278.198z"/>
      <path id="path13" fill="#0E4595"
            d="M524.307,142.687c-10.57-3.966-27.135-8.222-47.822-8.222           c-52.725,0-89.863,26.551-90.18,64.604c-0.297,28.129,26.514,43.821,46.754,53.185           c20.77,9.597,27.752,15.716,27.652,24.283c-0.133,13.123-16.586,19.116-31.924,19.116           c-21.355,0-32.701-2.967-50.225-10.274l-6.877-3.112l-7.488,43.823           c12.463,5.466,35.508,10.199,59.438,10.445c56.09,0,92.502-26.248,92.916-66.884           c0.199-22.27-14.016-39.216-44.801-53.188c-18.65-9.056-30.072-15.099-29.951-24.269           c0-8.137,9.668-16.838,30.559-16.838c17.447-0.271,30.088,3.534,39.936,7.5l4.781,2.259           L524.307,142.687"/>
      <path id="Path" fill="#0E4595"
            d="M661.615,138.464h-41.23c-12.773,0-22.332,3.486-27.941,16.234           l-79.244,179.402h56.031c0,0,9.16-24.121,11.232-29.418c6.123,0,60.555,0.084,68.336,0.084           c1.596,6.854,6.492,29.334,6.492,29.334h49.512L661.615,138.464z           M596.198,264.872c4.414-11.279,21.26-54.724,21.26-54.724           c-0.314,0.521,4.381-11.334,7.074-18.684l3.607,16.878c0,0,10.217,46.729,12.352,56.527h-44.293V264.872z"/>
      <path id="path16" style={{ fill: '#0e4595', fillOpacity: 1 }}
            d="M45.878906 138.46484 L45.197266 142.53711 C66.290228 147.64311 85.129273 155.0333 101.62305 164.22656           L148.96875 333.91406 L205.42383 333.85156 L289.42773 138.46484 L232.90234 138.46484 L180.66406 271.96094           L175.09961 244.83008 C174.83893 243.99185 174.55554 243.15215 174.26562 242.31055 L156.10547 154.99219           C152.87647 142.59619 143.50892 138.89684 131.91992 138.46484 L45.878906 138.46484z"/>
    </g>
  </svg>
);
